import Vue from 'vue';
import { Commit } from 'vuex';
import { DeviceCalibration, DeviceCalibrationGroupEdit } from '@/interfaces/calibration';

interface CalibrationState {
	calibrations: {
		[id: number]: DeviceCalibration;
	};
}

export default {
	namespaced: true,
	state: {
		calibrations: [],
	} as CalibrationState,
	getters: {
		getCalibrations: (state: CalibrationState): DeviceCalibration[] => {
			return Object.values(state.calibrations);
		},

		getGateway:
			(state: CalibrationState) =>
			(id: number): DeviceCalibration | undefined => {
				return state.calibrations[id];
			},
	},
	mutations: {
		SET_CALIBRATIONS(state: CalibrationState, calibrations: DeviceCalibration[]): void {
			const ret: { [id: number]: DeviceCalibration } = {};
			state.calibrations = calibrations.reduce((obj, calibration) => {
				obj[calibration.id] = calibration;
				return obj;
			}, ret);
		},

		CHANGE_CALIBRATION(
			state: CalibrationState,
			calibration: DeviceCalibration & { id: number }
		): void {
			const oldCalibration = state.calibrations[calibration.id] || {};
			Vue.set(state.calibrations, calibration.id, { ...oldCalibration, ...calibration });
		},

		CLEAN_CALIBRATIONS(state: CalibrationState): void {
			state.calibrations = {};
		},
	},
	actions: {
		async fetchCalibrations({ commit }: { commit: Commit }): Promise<void> {
			const queryParams = new URLSearchParams();
			queryParams.append('progress', 'True');

			try {
				const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/devices/calibration`, {
					params: queryParams,
				});
				if (response && response.status === 200) {
					commit('SET_CALIBRATIONS', response.data.data);
				}
			} catch (e) {
				commit('SET_CALIBRATIONS', []);
			}
		},

		async modifyCalibration(
			{ commit }: { commit: Commit },
			{ id_group, payload }: { id_group: number; payload: DeviceCalibrationGroupEdit }
		): Promise<void> {
			const response = await Vue.axios.put(
				`${process.env.VUE_APP_API_URL}/devices/calibration/${id_group}`,
				payload
			);
			if (response && response.status === 200) {
				commit('CHANGE_CALIBRATION', response.data.data);
			}
		},

		cleanGateways({ commit }: { commit: Commit }): void {
			commit('CLEAN_CALIBRATIONS');
		},

		cleanAllGateways({ commit }: { commit: Commit }): void {
			commit('CLEAN_CALIBRATIONS');
		},
	},
};
